import { Component, OnInit } from '@angular/core';
import { of as observableOf,  Observable } from "rxjs";
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ParameterService,AuthService } from 'core-dashboard';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app',
    templateUrl: './app.component.template.html',
})

export class DashboardMain {

    private sub: Subscription;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private parameters: ParameterService,
        private authService: AuthService, private translateService: TranslateService) {
    }

    ngOnInit() {
        this.sub = this.route.queryParams.subscribe((params: Params) => {
            //Set Default Language
            if (Object.keys(params).length != 0) {
                this.parameters.init(params);
            }
        });
    }

    ngOnDestroy() {
        if (this.sub != null)
            this.sub.unsubscribe();
    }
}
